import React from 'react';
import { imageCodes } from '../../template_codes/29/footer_codes';

export default function Footer() {
    return (
        <div>
            {/*                footer slider image                  */}
            <div class="carousel w-full">
                <div id="slide1" class="carousel-item relative w-full">
                    <img src={imageCodes.footer.image} alt="footer" class="w-full" />
                </div>
            </div>
            {/*                footer slider image                  */}
        </div>
    )
}
